import React from "react";
import ExtraLineItem from "./ExtraLineItem";

const ExtraLineItemTab = ({
  extraLineItemArray,
  i18n,
  renderNoResultsFound,
  closeModal
}) => {

  return (
    <div>
      {extraLineItemArray
        ? <ExtraLineItem
            extraLineItemArray={extraLineItemArray}
            i18n={i18n}
            closeModal={closeModal}
          />
        : renderNoResultsFound()}
    </div>
  );
};

export default ExtraLineItemTab;
